import React from 'react';

export interface GraphFrameProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  bodyClassName?: string;
}

export const GraphFrame: React.FC<GraphFrameProps> = ({
  title,
  subtitle,
  actions,
  children,
  className = '',
  bodyClassName = '',
}) => (
  <section
    className={`flex h-full flex-col bg-white border border-rowing-gray-200 rounded-xl shadow-sm ${className}`}
    data-testid="graph-frame"
  >
    <header className="flex flex-col gap-2 border-b border-rowing-gray-200 p-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h3 className="text-base font-semibold text-rowing-navy">{title}</h3>
        {subtitle ? <p className="text-sm text-rowing-gray-600">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </header>
    <div className={`flex-1 min-h-[16rem] p-4 ${bodyClassName}`}>{children}</div>
  </section>
);
